import React from 'react'
import PropTypes from 'prop-types'

/**
 * Tên tài khoản của cột "Tài khoản" (M18), kèm ĐIỂM NGẮT MỀM `<wbr>` sau mỗi `@` và `_`.
 *
 * Vì sao cần: tên tài khoản ở MCVN có hai dạng — `thanhnm_laservibe` và `huyennn1@foobla.com` —
 * và CẢ HAI đều là MỘT TỪ với trình duyệt (`@`, `_`, `.` không phải điểm ngắt dòng mặc định).
 * Cột hẹp hơn chuỗi đó thì chỉ còn hai kết cục: tràn ra ngoài ô (bị cắt), hoặc — nếu bật
 * `overflow-wrap` — ngắt ở ĐÚNG ký tự chạm mép, ra `huyennn1@foobla.c` / `om`. Cả hai đều là thứ
 * người vận hành đọc thành "màn hình hỏng". `<wbr>` cho trình duyệt một chỗ ngắt CÓ NGHĨA để chọn
 * trước, nên dòng thứ hai luôn bắt đầu bằng một mảnh đọc được: `huyennn1@` / `foobla.com`.
 *
 * ⚠️ `<wbr>` chỉ là ĐỀ NGHỊ, không phải bảo đảm — mảnh dài hơn cả bề rộng cột vẫn phải cắt cứng.
 *    Lớp `.VcActorCell` (SCSS) vì thế vẫn giữ `overflow-wrap: break-word`, và nó GÁNH VIỆC THẬT:
 *    đo trong chromium ở bề rộng nội dung 108px, `↳ nguyenvanlongquangtruong@foobla.com` không có
 *    quy tắc đó thì dòng đầu dài 26 ký tự, tràn hẳn khỏi ô.
 *
 * ⚠️ KHÔNG ngắt sau `.`: `foobla.com` ngắn hơn mọi cột đang dùng, thêm chỗ ngắt ở đó chỉ tạo cơ hội
 *    cho một dòng thứ ba vô ích (`huyennn1@` / `foobla.` / `com`).
 *
 * ⚠️ Tách thành file riêng để có chỗ KIỂM, cùng lý do đã ghi ở `ReportSubtitle`: trong repo này
 *    không file test nào import một màn hình nào, nên mọi nhánh JSX nằm trong `OutputReportPage`
 *    (1.400 dòng) có mutation score 0 theo cấu tạo.
 */

/** Cắt chuỗi thành các mảnh KẾT THÚC bằng `@` hoặc `_`; mảnh cuối là phần còn lại. */
export const accountChunks = (value) => {
    const text = value == null ? '' : String(value)
    const chunks = []
    let start = 0

    for (let i = 0; i < text.length; i += 1) {
        if (text[i] === '@' || text[i] === '_') {
            chunks.push(text.slice(start, i + 1))
            start = i + 1
        }
    }

    // Tên kết thúc đúng bằng `@`/`_` thì không còn phần đuôi — đừng đẩy một mảnh rỗng vào, nó sinh
    // một `<wbr>` thừa ở cuối chuỗi (chỗ ngắt không bao giờ dùng tới).
    if (start < text.length) chunks.push(text.slice(start))

    return chunks
}

function AccountLabel({value}) {
    const chunks = accountChunks(value)

    return (
        <>
            {chunks.map((chunk, index) => (
                <React.Fragment key={index}>
                    {chunk}
                    {index < chunks.length - 1 && <wbr/>}
                </React.Fragment>
            ))}
        </>
    )
}

AccountLabel.propTypes = {
    value: PropTypes.string,
}

export default AccountLabel
